<template>
  <svg
      :width="size"
      :height="size"
      viewBox="0 0 100 110">
    <rect
        id="background"
        style="fill:#FFFFFF;fill-opacity:0.7;stroke:#000000;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:fill markers stroke"
        width="100"
        height="110"
        x="0"
        y="0"/>
    <ellipse
        id="head"
        style="fill-opacity:1;stroke:#000000;stroke-width:1;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:fill markers stroke"
        cx="50"
        cy="45"
        rx="24"
        ry="33"
        :fill="skinColor"/>
    <path
        id="shirt"
        d="M 0,110 V 84 c 0,0 24,-12 27,-12 3,0 10,26 22,26 11,2 17,-13 21,-25 3,-3 30,14 30,14 v 23"
        style="stroke:#000000;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
        :fill="jerseyColor"/>
    <rect
        id="frame"
        style="fill:none;stroke:#000000;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:fill markers stroke"
        width="100"
        height="108"
        x="0"
        y="1"/>
  </svg>
</template>

<script>
const ethnicsProps = [
  {
    name: 'african',
    countries: ['gh', 'ng', 'sn', 'ci', 'et', 'tg', 'ma', 'ug', 'cm', 'ne', 'ao', 'ke', 'na'],
    skinColor: '#3f2c20ff'
  },
  {
    name: 'arab',
    countries: ['tr', 'ir', 'tn', 'dz', 'ae', 'eg', 'lb', 'sa', 'iq', 'jo', 'kw', 'pk'],
    skinColor: '#AE877AFF'
  },
  {
    name: 'centralEuropean',
    countries: ['de', 'ch', 'at', 'nl', 'en', 'sc', 'za', 'au', 'nz', 'ie', 'jm', 'ca', 'is', 'fr', 'be', 'li', 'lu', 'ey'],
    skinColor: '#CDA392FF'
  },
  {
    name: 'hispano',
    countries: ['mt', 'it', 'gr', 'br', 'pt', 'es', 'mx', 'py', 'uy', 've', 'pe', 'ar', 'pr', 'cl', 'cr', 'ec', 'co', 'bo', 'bs'],
    skinColor: '#CCA385FF'
  },
  {
    name: 'asian',
    countries: ['ko', 'jp', 'kr', 'id', 'my'],
    skinColor: '#AA9079FF'
  },
  {
    name: 'easterEurope',
    countries: ['cz', 'pl', 'ua', 'hr', 'ro', 'hu', 'ru', 'sk', 'yu', 'bg', 'lv', 'lt', 'ba', 'ee', 'al', 'by', 'cy', 'mk'],
    skinColor: '#F5D6CEFF'
  },
  {
    name: 'scandinavian',
    countries: ['dk', 'se', 'fi', 'no'],
    skinColor: '#E1A69EFF'

  }
];


const ethnicsMap = [];

ethnicsProps.forEach((ethnic) => {
  ethnic.countries.forEach((country) => {
    ethnicsMap.push({
      country: country,
      ethnic: ethnic
    })
  })
});

const ethnics = {
  getSkinColor: (country) => {
    let entry = ethnicsMap.find((mapEntry) => {
      return mapEntry.country == country
    });
    if (!entry)
      entry = ethnicsMap;
    return entry.ethnic.skinColor
  }
};

export default {
  props: {
    size: String,
    player: Object
  },
  computed: {
    skinColor() {
      return ethnics.getSkinColor(this.country)
    },
    country() {
      return this.player.nationality
    },
    jerseyColor(){
      return this.player.team.primaryColor
    }
  }
}
</script>
